import React, { useEffect, useState } from 'react';
import { LAUNCH_WINDOW_SECONDS } from '../data/unstuckContent';
type CountdownTimerProps = {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
};
const pad = (n: number) => String(n).padStart(2, '0');
export function CountdownTimer({
  label,
  className = '',
  size = 'md'
}: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(LAUNCH_WINDOW_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(s => s > 0 ? s - 1 : 0), 1000);
    return () => window.clearInterval(id);
  }, []);
  const units = [{
    value: pad(Math.floor(remaining / 3600)),
    unit: 'hrs'
  }, {
    value: pad(Math.floor(remaining % 3600 / 60)),
    unit: 'min'
  }, {
    value: pad(remaining % 60),
    unit: 'sec'
  }];
  const digit = size === 'lg' ? 'text-4xl sm:text-5xl' : 'text-3xl sm:text-4xl';
  return <div className={className} data-id="element-46" data-mp="2zr5o4n0inw4q">
      <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-champagne" data-id="element-47" data-mp="2zs6xmn1vwakc">
        {label}
      </p>
      <div className="mt-2 flex items-start justify-center gap-3 sm:gap-4" role="timer" aria-live="off" data-id="element-48" data-mp="1bzdnkms1mo29">
        {units.map(({
        value,
        unit
      }, i) => <React.Fragment key={unit} data-id="element-49" data-mp="12423rq1s2qnn" data-mpi={i}>
            {i > 0 && <span className={`font-display font-semibold leading-none text-charcoal-500 ${digit}`} aria-hidden="true" data-id="element-50" data-mp="1712dcaxu6bji">
                :
              </span>}
            <span className="text-center" data-id="element-51" data-mp="1zoy4l04mzb8w">
              <span className={`block font-display font-semibold leading-none text-ivory-50 ${digit}`} data-id="element-52" data-mp="1zs3tae9csb43">
                {value}
              </span>
              <span className="mt-1 block text-[9px] font-medium uppercase tracking-[0.2em] text-muted" data-id="element-53" data-mp="1pyn2zk8fde56">
                {unit}
              </span>
            </span>
          </React.Fragment>)}
      </div>
    </div>;
}